import type { PaymentMethodsState } from "../Types/paymentsPaymentTypes";

/**
 * The available payment methods, loaded once when the dialog opens. A reducer
 * rather than useState because the whole set arrives together — cards, bank
 * accounts and which of cheque/EFT/e-transfer/wire this company may use.
 */
type Action = { type: "SET_METHODS"; payload: PaymentMethodsState };

export function paymentMethodsReducer(
  _state: PaymentMethodsState,
  action: Action,
): PaymentMethodsState {
  switch (action.type) {
    case "SET_METHODS":
      return { ...action.payload };
  }
}

export const defaultPaymentMethodsState: PaymentMethodsState = {
  bankAccounts: [],
  creditCards: [],
  isChequePermitted: false,
  isEFTPermitted: false,
  isETransferPermitted: false,
  isWirePermitted: false,
  defaultMethod: undefined,
};
